<template>
    <a href="javascript:void(0)" @click="openModal"><slot></slot></a>
</template>

<script>
import eventBus from '@/event-bus';

export default {
    methods: {
        openModal() {
            eventBus.$emit('emailSignatureModalOpened');
        }
    }
}
</script>
